import Container from '@admin/components/container'
import Chart from '@admin/components/chart'
import Icon from '@admin/components/icon'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import numeral from 'numeral'
import moment from 'moment'
import React from 'react'
import qs from 'qs'

class Card extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    config: PropTypes.object,
    daterange: PropTypes.object,
    data: PropTypes.object,
    isExpanded: PropTypes.bool,
    program: PropTypes.object,
    service: PropTypes.object,
    showChart: PropTypes.bool,
    showTable: PropTypes.bool
  }

  render() {
    const { data, showChart, showTable } = this.props
    const metric = this._getMetric()
    return (
      <div className="maha-dashboard-card-detail">
        <div className="maha-dashboard-card-detail-header">
          <div className="maha-dashboard-card-detail-title">
            <T text={ this._getLabel('t(Subscriptions)') } />
          </div>
          <div className="maha-dashboard-card-detail-subtitle">
            { data.summary.label }
          </div>
          <div className="maha-dashboard-card-detail-metric">
            <div className="maha-dashboard-card-detail-metric-inner">
              <div className="maha-dashboard-card-detail-metric-text">
                { metric.value }
              </div>
              { metric.delta &&
                <div className={`maha-dashboard-card-detail-metric-delta ${ metric.delta.direction }`}>
                  <Icon icon={`caret-${ metric.delta.direction }`} /> { metric.delta.percent }
                </div>
              }
            </div>
          </div>
        </div>
        { showChart &&
          <div className="maha-dashboard-card-detail-chart">
            <Chart { ...this._getChart() } />
          </div>
        }
        { showTable &&
          <div className="maha-dashboard-card-detail-table">
            <table>
              <thead>
                <tr>
                  <th><T text="t(Date)" /></th>
                  <th><T text="t(Subscriptions)" /></th>
                </tr>
              </thead>
              <tbody>
                { data.details.map((record, index) => (
                  <tr key={`record_${index}`} onClick={ this._handleClick.bind(this, record) }>
                    <td>{ record.label }</td>
                    <td>{ record.value }</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        }
      </div>
    )
  }

  _getChart() {
    const { config, data, isExpanded } = this.props
    return {
      type: config.type,
      datasets: [
        {
          color: config.color,
          label: 't(Subscriptions)',
          points: data.details.map(record => ({
            x: record.label,
            y: record.value
          }))
        }
      ],
      options: {
        aspectRatio: isExpanded ? 2 : 1.5,
        legend: isExpanded,
        points: config.points,
        tension: config.tension,
        grid: isExpanded
      }
    }
  }

  _getLabel(label) {
    const { config, service, program } = this.props
    const { team } = this.context.admin
    if(config.title) return config.title
    if(config.scope === 'program' && team.has_programs) return `${label} - ${program.title}`
    if(config.scope === 'service') return `${label} - ${service.title}`
    return label
  }

  _getMetric() {
    const { data } = this.props
    const { current, previous, delta } = data.summary
    const percent = delta === 0 ? null : previous === 0 ? 1 : Math.abs((delta) / previous)
    return {
      value: current < 1000 ? current : numeral(current).format('0.00a').toUpperCase(),
      delta: percent > 0 ? {
        direction: delta < 0 ? 'down' : 'up',
        percent: percent && percent !== 0 ? numeral(percent).format('0.00%') : null
      } : null
    }
  }

  _handleClick(record) {
    const { config } = this.props
    const filter = qs.stringify({
      subscription_type: config.subscription_type,
      start_date: moment.utc(record.start).format('YYYY-MM-DD'),
      end_date: moment.utc(record.end).format('YYYY-MM-DD')
    }, { encode: false })
    this.context.router.push(`/admin/dashboards/affiliate_subscriptions?${filter}`)
  }
}

const mapResources = (props, context) => ({
  data: {
    endpoint: '/api/admin/dashboards/affiliate_subscriptions/card',
    filter: {
      subscription_type: props.config.subscription_type,
      daterange: props.daterange 
    }
  }
})

export default Container(mapResources)(Card)